import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import Menu from "./Menu";
import { getNavBarClass, isMobileDevice } from "../../helpers";
import { MOBILE_MENU_HEIGHT } from "../../constants";

const Navbar = ({ isTransparent, menuColor, headerColor, menuButtonColor }) => {
  const [navBarClassName, setNavBarClass] = useState("");
  const isMobile = isMobileDevice(window);
  const location = useLocation();
  const path = location.pathname;
  const isHomePage = path === "/";

  useEffect(() => {
    const navBarClass = getNavBarClass(isMobile, path);
    setNavBarClass(navBarClass);

    // Reset navbar classes when route changes
    const navbar = document.getElementById("navbar");
    if (navbar) {
      navbar.classList = `menubar ${navBarClass}`;
    }
  }, [isMobile, path]);

  // let position = "absolute";
  // let navbarTop = 0;
  // let lastScrollPosition = 0;
  // const supportPageOffset = window.pageYOffset !== undefined;

  // const onScroll = () => {
  //   const navbar = document.getElementById("navbar");
  //   const mobileProjectCatBar = document.getElementById("mobile-project-cat");
  //   const headerText = document.getElementsByClassName("navbar-text");
  //   const menuButton = document.getElementsByClassName("menuIcon");

  //   const currentScrollPosition = supportPageOffset
  //     ? window.pageYOffset
  //     : document.documentElement.scrollTop;
  //   //On Top of page
  //   if (currentScrollPosition <= 0) {
  //     position = "absolute";
  //     navbarTop = 0;
  //     lastScrollPosition = 0;

  //     navbar.style.background = null; //remove translucent white bkgd from sticky nav
  //     navbar.classList = null;
  //     navbar.classList = `menubar ${navBarClassName}`;
  //     navbar.style.transition = "background-color 200ms linear";

  //     if (mobileProjectCatBar) {
  //       mobileProjectCatBar.style.top = `${MOBILE_MENU_HEIGHT}px`;
  //       mobileProjectCatBar.style.position = position;
  //     }

  //     for (let i = 0; i < headerText.length; i++) {
  //       headerText[i].style.color = headerColor;
  //     }

  //     for (let i = 0; i < menuButton.length; i++) {
  //       menuButton[i].style["background-color"] = menuColor;
  //     }
  //   } else {
  //     //Scrolling Down
  //     if (currentScrollPosition > lastScrollPosition) {
  //       position = "absolute";
  //       let { top, height } = navbar.getBoundingClientRect();
  //       const isNavHidden = top < -height;
  //       //when navbar is hidden
  //       if (isNavHidden) {
  //         top = -height;
  //       }
  //       navbarTop = currentScrollPosition + top;

  //       if (mobileProjectCatBar) {
  //         mobileProjectCatBar.style.top = isNavHidden
  //           ? 0
  //           : `${MOBILE_MENU_HEIGHT + top}px`;
  //         mobileProjectCatBar.style.position = "fixed";
  //       }

  //       //Scrolling Up - Display Nav Bar
  //     } else if (currentScrollPosition < lastScrollPosition) {
  //       const { top } = navbar.getBoundingClientRect();
  //       const isNavVisible = top >= 0;
  //       //When full navbar is visible
  //       if (isNavVisible) {
  //         navbarTop = 0;
  //         position = "fixed";
  //       }
  //       //Changing height of navbar
  //       if (mobileProjectCatBar) {
  //         const mobileCatBarHeight = isNavVisible
  //           ? MOBILE_MENU_HEIGHT
  //           : 50 + top;
  //         mobileProjectCatBar.style.position = "fixed";
  //         mobileProjectCatBar.style.top = `${mobileCatBarHeight}px`;
  //       }
  //     }

  //     navbar.style.background = "rgba(255, 255, 255, 0.8)";
  //     navbar.style.transition = "background-color 200ms linear";

  //     for (let i = 0; i < headerText.length; i++) {
  //       headerText[i].style.color = "black";
  //     }

  //     for (let i = 0; i < menuButton.length; i++) {
  //       menuButton[i].style["background-color"] = "black";
  //     }

  //     lastScrollPosition = currentScrollPosition;
  //   }
  //   navbar.style.position = position;
  //   navbar.style.top = `${navbarTop}px`;
  // };

  // window.addEventListener("scroll", onScroll, { passive: true });

  useEffect(() => {
    const navbar = document.getElementById("navbar");
    navbar.style.top = `0px`;

    let position = "absolute";
    let navbarTop = 0;
    let lastScrollPosition = 0;
    const supportPageOffset = window.pageYOffset !== undefined;

    const onScroll = () => {
      const mobileProjectCatBar = document.getElementById("mobile-project-cat");
      const headerText = document.getElementsByClassName("navbar-text");
      const menuButton = document.getElementsByClassName("menuIcon");

      if (!navbar) return;

      const currentScrollPosition = supportPageOffset
        ? window.pageYOffset
        : document.documentElement.scrollTop;

      //On Top of Page
      if (currentScrollPosition <= 0) {
        position = "absolute";
        navbarTop = 0;
        lastScrollPosition = 0;

        navbar.style.background = null;
        navbar.classList = `menubar ${navBarClassName}`;
        navbar.style.transition = "background-color 200ms linear";

        if (mobileProjectCatBar) {
          mobileProjectCatBar.style.top = `${MOBILE_MENU_HEIGHT}px`;
          mobileProjectCatBar.style.position = position;
        }

        for (let i = 0; i < headerText.length; i++) {
          headerText[i].style.color = headerColor;
        }

        for (let i = 0; i < menuButton.length; i++) {
          menuButton[i].style["background-color"] = menuColor;
        }
      } else {
        //Scrolling Down
        if (currentScrollPosition > lastScrollPosition) {
          position = "absolute";
          let { top, height } = navbar.getBoundingClientRect();
          const isNavHidden = top < -height;
          if (isNavHidden) top = -height;
          navbarTop = currentScrollPosition + top;

          if (mobileProjectCatBar) {
            mobileProjectCatBar.style.top = isNavHidden
              ? 0
              : `${MOBILE_MENU_HEIGHT + top}px`;
            mobileProjectCatBar.style.position = "fixed";
          }

          //Scrolling Up
        } else if (currentScrollPosition < lastScrollPosition) {
          const { top } = navbar.getBoundingClientRect();
          const isNavVisible = top >= 0;
          if (isNavVisible) {
            navbarTop = 0;
            position = "fixed";
          }
          if (mobileProjectCatBar) {
            const mobileCatBarHeight = isNavVisible
              ? MOBILE_MENU_HEIGHT
              : 50 + top;
            mobileProjectCatBar.style.position = "fixed";
            mobileProjectCatBar.style.top = `${mobileCatBarHeight}px`;
          }
        }

        navbar.style.background = "rgba(255, 255, 255, 0.8)";
        navbar.style.transition = "background-color 200ms linear";

        for (let i = 0; i < headerText.length; i++) {
          headerText[i].style.color = "black";
        }

        for (let i = 0; i < menuButton.length; i++) {
          menuButton[i].style["background-color"] = "black";
        }

        lastScrollPosition = currentScrollPosition;
      }

      navbar.style.position = position;
      navbar.style.top = `${navbarTop}px`;
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [headerColor, menuColor, navBarClassName]);

  return (
    <div id='navbar' className={"menubar " + navBarClassName}>
      <div className='menubar-sitetitle'>
        <div className='sitetitle-container'>
          <Link
            id='logo'
            className='site-link navbar-text'
            to='/'
            style={{ color: headerColor }}
          >
            <h1 id='site-title'>
              PAUL SANGHA
              <span style={{ fontFamily: "LinoTypeLight" }}> CREATIVE</span>
            </h1>
          </Link>
        </div>
      </div>
      <Menu
        isMobile={isMobile}
        menuButtonColor={menuButtonColor}
        menuColor={menuColor}
        isTransparent={isTransparent}
        headerColor={headerColor}
        isHomePage={isHomePage}
      />
    </div>
  );
};

export default Navbar;
